import { Main_Plain } from 'monica-alexandria';
import styled from 'styled-components';

const OfferPreviewExportAction = styled.div`
    display: flex;
    justify-content: flex-end;

    @media print {
        display: none;
    }
`;

export default function Offer_Preview_Export_Action(props) {
    return (
        <OfferPreviewExportAction>
            <Main_Plain
                iconLeft="Download"
                text={props.copy.exportPdf}
                onClick={props.onExportPdf}
            ></Main_Plain>
        </OfferPreviewExportAction>
    );
}
